module.exports = __webpack_public_path__ + "img/gb831.prt.ccf9f5ec.jpg";